(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-scbd-hero-video]').forEach((video) => {
      if (video.dataset.scbdInitialized) return;
      video.dataset.scbdInitialized = 'true';
      const desktop = matchMedia('(min-width: 769px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const allowed = () => !reduced.matches && !navigator.connection?.saveData && (desktop.matches || video.dataset.mobileImageOnly === 'false');
      const update = () => {
        if (!allowed()) {
          video.pause();
          video.classList.remove('is-playing');
          if (video.hasAttribute('src')) {
            video.removeAttribute('src');
            video.load();
          }
          return;
        }
        if (!video.hasAttribute('src')) {
          video.src = video.dataset.src;
          video.autoplay = true;
          video.load();
        }
        video.play().catch(() => {});
      };
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      video.addEventListener('error', () => video.classList.remove('is-playing'));
      desktop.addEventListener('change', update);
      reduced.addEventListener('change', update);
      const schedule = () => {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if ('requestIdleCallback' in window) requestIdleCallback(update, { timeout: 1500 });
          else setTimeout(update, 200);
        }));
      };
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
